import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function GradDateField({ form, handleChange }) {
    // Parse "YYYY-MM" safely in local time
    let value = null;
    if (form.gradDate) {
        const [y, m] = form.gradDate.split("-").map(Number);
        if (!Number.isNaN(y) && !Number.isNaN(m)) {
            // Use numeric constructor (local time) to avoid UTC shift
            value = new Date(y, m - 1, 1);
        }
    }

    // First day of current month as minDate
    const now = new Date();
    const minDate = new Date(now.getFullYear(), now.getMonth(), 1);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label="Expected Graduation Date *"
                views={["year", "month"]}
                value={value}
                minDate={minDate}
                onChange={(newValue) => {
                    const v =
                        newValue instanceof Date && !isNaN(newValue)
                            ? `${newValue.getFullYear()}-${String(
                                newValue.getMonth() + 1
                            ).padStart(2, "0")}`
                            : "";
                    handleChange({ target: { name: "gradDate", value: v } });
                }}
                format="MMMM yyyy"
                slotProps={{
                    textField: {
                        fullWidth: true,
                        required: true,
                        InputLabelProps: { shrink: true },
                        placeholder: "Month Year",
                    },
                }}
            />
        </LocalizationProvider>
    );
}